'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/monthsAfter.js
// module id = 719
// module chunks = 0